if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      quantityInput = undefined;
      quantityForm = undefined;
      onVariantChangeUnsubscriber = undefined;
      cartUpdateUnsubscriber = undefined;
      abortController = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];

      constructor() {
        super();
        this.quantityInput = this.querySelector('.quantity__input');
        // if(document.querySelectorAll(".block_post-length-size").length > 0){ 
        //   this.initInput()
        // }
      }
      // initInput() {
      //   const inputs = document.querySelectorAll('.block_post-length-size input[type="radio"]');
      //   inputs.forEach(input => {
      //     input.addEventListener('change', () => this.handleChangeinput(input));
      //   });
      // }
      // handleChangeinput(input) {
      //   // console.log('input',input);
      //   // setTimeout(() => {
          
      //   // if (!input) return;
      //   //   const relation = input.getAttribute("data-relation");
      //   //   const length = input.getAttribute("data-length");
      //   //   const price = input.getAttribute("data-add-on-price");
      //   //   const addOnPrice = input.getAttribute("data-price");
        
      //   //   const relationInput = document.querySelector('#product-propeties-relationKey');
      //   //   if (relationInput) relationInput.value = relation || '';
        
      //   //   const lengthInput = document.querySelector('#product-propeties-post-length');
      //   //   if (lengthInput) lengthInput.value = length || '';

      //   //   const priceInput = document.querySelector('#product_add_on_price');
      //   //   if (priceInput) priceInput.value = price || '';

      //   //   if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {    
      //   //     const hiddenPriceInput = document.getElementById('hidden_variant_price');
      //   //     const basePrice = hiddenPriceInput ? parseInt(hiddenPriceInput.value, 10) || 0 : 0;
      //   //     const addOnCents = typeof addOnPrice !== 'undefined' ? parseInt(addOnPrice, 10) || 0 : 0;
      //   //     const totalCents = basePrice + addOnCents;
      //   //     const moneyFormat = Shopify.moneyFormat || "{{amount}}";
      //   //     let formatted = Shopify.formatMoney(totalCents, moneyFormat);

      //   //     formatted = formatted.replace(/(\.\d{2})/, '');

      //   //     const currencyCode = document.body.dataset.shopCurrency || '';
      //   //     const displayTotal = currencyCode === 'USD'
      //   //       ? formatted
      //   //       : `${formatted} ${currencyCode}`;      
      //   //         document.querySelectorAll('.price__container .price__regular .price-item--regular').forEach(el => { el.innerHTML = displayTotal; });
      //   //       console.log('more inputs');
      //   //   } 
      //   // }, 900);
      // }
      connectedCallback() {
        this.initializeProductSwapUtility();

        this.onVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this)
        );

        this.initQuantityHandlers();
        this.dispatchEvent(new CustomEvent('product-info:loaded', { bubbles: true }));
        setTimeout(() => this.hideSuspendedCombinations(), 50);
      }

      addPreProcessCallback(callback) {
        this.preProcessHtmlCallbacks.push(callback);
      }

      initQuantityHandlers() {
        if (!this.quantityInput) return;

        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;

        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber();
        this.cartUpdateUnsubscriber?.();
      }

      initializeProductSwapUtility() {
        this.preProcessHtmlCallbacks.push((html) =>
          html.querySelectorAll('.scroll-trigger').forEach((element) => element.classList.add('scroll-trigger--cancel'))
        );
        this.postProcessHtmlCallbacks.push((newNode) => {
          window?.Shopify?.PaymentButton?.init();
          window?.ProductModel?.loadShopifyXR();
        });
      }

      handleOptionValueChange({ data: { event, target, selectedOptionValues } }) {
        if (!this.contains(event.target)) return;

        this.resetProductFormState();

        const productUrl = target.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;
        this.pendingRequestUrl = productUrl;
        const shouldSwapProduct = this.dataset.url !== productUrl;
        const shouldFetchFullPage = this.dataset.updateUrl === 'true' && shouldSwapProduct;

        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(productUrl, selectedOptionValues, shouldFetchFullPage),
          targetId: target.id,
          callback: shouldSwapProduct
            ? this.handleSwapProduct(productUrl, shouldFetchFullPage)
            : this.handleUpdateProductInfo(productUrl),
        });
        
      }

      resetProductFormState() {
        const productForm = this.productForm;
        productForm?.toggleSubmitButton(true);
        productForm?.handleErrorMessage();
      }

      handleSwapProduct(productUrl, updateFullPage) {
        return (html) => {
          this.productModal?.remove();
          
          const selector = updateFullPage ? "product-info[id^='MainProduct']" : 'product-info';
          const variant = this.getSelectedVariant(html.querySelector(selector));
          this.updateURL(productUrl, variant?.id);

          if (updateFullPage) {
            document.querySelector('head title').innerHTML = html.querySelector('head title').innerHTML;

            HTMLUpdateUtility.viewTransition(
              document.querySelector('main'),
              html.querySelector('main'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          } else {
            HTMLUpdateUtility.viewTransition(
              this,
              html.querySelector('product-info'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          }

          const scripts = html.querySelectorAll("script");
          scripts.length>0 && scripts.forEach(script => {
            if (script.textContent.includes("window.selectedVariantData")) {
              const match = script.textContent.match(/window\.selectedVariantData\s*=\s*(\{[\s\S]*?\});?/);
              if (match && match[1]) {
                try {
                  const selectedVariant = (new Function(`return ${match[1]}`))();
                  window.selectedVariantData = selectedVariant;
                  window.tryFeatureButtons = document.querySelectorAll(".block_button_try-on-button-trigger");
                  window.updateTryFeatureFunction();
                  if (window.tryFeatureButtons) {
                    window.tryFeatureButtons.forEach((container) => {
                      const button = container.querySelector("button");
                      if (button) {
                        button.addEventListener("click", function () {
                          const productId = button.getAttribute("data-product-id");
                          const variantId = document.querySelector(".product-variant-id")?.value;
                          const cookies = document.cookie.split(";");
                          let cookiename = 'applicable_zone';
                          let applicableZone = "";
                          for (let cookie of cookies) {
                            cookie = cookie.trim();
                            if (cookie.startsWith(cookiename + "=")) {
                              applicableZone = cookie.substring(cookiename.length + 1);
                            }
                          }
                          const postLength = document.querySelector('input[name="post-length"]:checked')?.value || "";
                          const baseUrl = `${window.location.origin}/pages/TASH-studio`;
                          let url = applicableZone
                            ? `${baseUrl}?productId=${productId}&variantId=${variantId}&zone=${applicableZone}`
                            : `${baseUrl}?productId=${productId}&variantId=${variantId}`;
                          if (postLength) {
                            url += `&related_sku=${postLength}`;
                          }
                          window.open(url, "_blank");
                        });
                      }
                    });
                  }
                  $('.input.product-variant-id').trigger('change');
                } catch (e) {
                  console.error("Failed to safely parse selectedVariantData:", e);
                }
              }
            }
          });
        };
      }

      renderProductInfo({ requestUrl, targetId, callback }) {
        this.abortController?.abort();
        this.abortController = new AbortController();

        fetch(requestUrl, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            this.pendingRequestUrl = null;
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            // console.log(html);
            callback(html);
          })
          .then(() => {
            
            // set focus to last clicked option value
            document.querySelector(`#${targetId}`)?.focus();
            this.hideSuspendedCombinations();
            document.querySelectorAll('.block_post-length-size').forEach(el => {
              el.classList.add('skeleton');
            });
            document.querySelectorAll('.product-form__submit')
            .forEach(el => {
              el.classList.add('backing_block_cursor');
            });
             setTimeout(() => {
                // this.initInput();
                postLengthInit();
                initializeProductGallery();
                // console.log('hello123!');
             }, 700);
          })
          .catch((error) => {
            if (error.name === 'AbortError') {
              console.log('Fetch aborted by user');
            } else {
              console.error(error);
            }
          });
      }

      getSelectedVariant(productInfoNode) {
        const selectedVariant = productInfoNode.querySelector('variant-selects [data-selected-variant]')?.innerHTML;
        return !!selectedVariant ? JSON.parse(selectedVariant) : null;
      }

      buildRequestUrlWithParams(url, optionValues, shouldFetchFullPage = false) {
        const params = [];

        !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);

        if (optionValues.length) {
          params.push(`option_values=${optionValues.join(',')}`);
        }

        return `${url}?${params.join('&')}`;
      }

      updateOptionValues(html) {
        const variantSelects = html.querySelector('variant-selects');
        if (variantSelects) {
          HTMLUpdateUtility.viewTransition(this.variantSelectors, variantSelects, this.preProcessHtmlCallbacks);
        }
      }

      handleUpdateProductInfo(productUrl) {
        return (html) => {
          const variant = this.getSelectedVariant(html);         

          this.pickupAvailability?.update(variant);
          this.updateOptionValues(html);
          this.updateURL(productUrl, variant?.id);
          this.updateVariantInputs(variant?.id);

          if (!variant) {
            if($('#try-on-button').length>0)
            {
                $('#try-on-button').hide();
            }
            this.setUnavailable();
            return;
          }

          this.updateMedia(html, variant?.featured_media?.id);  
          
          const newImages = html.getElementById(`variants-metafiledimage-${this.sectionId}`);
          const currentImages = this.querySelector(`#variants-metafiledimage-${this.dataset.section}`);
          const newBackorderWrapper = html.getElementById(`variants-custom-backordertime-${this.sectionId}`);
          const currentBackorderWrapper = this.querySelector(`#variants-custom-backordertime-${this.dataset.section}`);
          const newBackingWrapper = html.getElementById(`backing_main_${this.sectionId}`);
          const currentBackingWrapper = this.querySelector(`#backing_main_${this.dataset.section}`);
          
          const newBackingInput = html.getElementById(`product-variant-backorder-id-${this.sectionId}`);
          const currentBackingInput = this.querySelector(`#product-variant-backorder-id-${this.dataset.section}`);

          const newGemstoneBackorderWrapper = html.getElementById(`Gemstoneweight-${this.sectionId}`);
          const currentGemstoneBackorderWrapper = this.querySelector(`#Gemstoneweight-${this.dataset.section}`);

          const stickyImages = html.getElementById(`product-sticky-${this.sectionId}`);
          const stickycurrentImages = this.querySelector(`#product-sticky-${this.dataset.section}`);

          if (newBackingWrapper && currentBackingWrapper) {
            currentBackingWrapper.innerHTML = newBackingWrapper.innerHTML;
          }

          if (stickyImages && stickycurrentImages) {
            stickycurrentImages.innerHTML = stickyImages.innerHTML;
          }

          if (newImages && currentImages) {
            currentImages.innerHTML = newImages.innerHTML;
          }
          
          if (newGemstoneBackorderWrapper && currentGemstoneBackorderWrapper) {
            currentGemstoneBackorderWrapper.innerHTML = newGemstoneBackorderWrapper.innerHTML;
          }

          const newBottomImages = html.querySelector('.block_product-varient-images');
          const currentBottomImages = this.querySelector('.block_product-varient-images');

          if (newBottomImages && currentBottomImages) {
            currentBottomImages.innerHTML = newBottomImages.innerHTML;
          }

          if (newBackorderWrapper && currentBackorderWrapper) {
            currentBackorderWrapper.innerHTML = newBackorderWrapper.innerHTML;                          
          }

          if (newBackingInput && currentBackingInput) {
            currentBackingInput.innerHTML = newBackingInput.innerHTML;
          }

          const atcInputs = document.querySelectorAll('input[name="properties[_atc]"]');
          if (atcInputs.length > 0) {
            atcInputs.forEach(el => el.remove());
          }
          setTimeout(() => {
            tosOrderTags(variant.id);
          }, 500);

          const updateSourceFromDestination = (id, shouldHide = (source) => false) => {
            const source = html.getElementById(`${id}-${this.sectionId}`);
            const destination = this.querySelector(`#${id}-${this.dataset.section}`);
            if (source && destination) {
              destination.innerHTML = source.innerHTML;
              destination.classList.toggle('hidden', shouldHide(source));
            }
          }; 

          
          updateSourceFromDestination('price');
          updateSourceFromDestination('price-sticky');
          updateSourceFromDestination('Sku', ({ classList }) => classList.contains('hidden'));
          updateSourceFromDestination('Inventory', ({ innerText }) => innerText === '');
          updateSourceFromDestination('Volume');
          updateSourceFromDestination('Price-Per-Item', ({ classList }) => classList.contains('hidden'));
          if(document.querySelectorAll(".block_post-length-size").length > 0){
            updateSourceFromDestination('Postlength');
            updateSourceFromDestination('postLengthInputs');
            // this.initInput();
            // let inputinfo = document.querySelector('.block_post-length-size input[type="radio"]:checked');
            // postLengthInit();
            // console.log('hello456!');
            // this.handleChangeinput(inputinfo);
          }
          
          this.updateQuantityRules(this.sectionId, html);
          this.querySelector(`#Quantity-Rules-${this.dataset.section}`)?.classList.remove('hidden');
          this.querySelector(`#Volume-Note-${this.dataset.section}`)?.classList.remove('hidden');

          this.productForm?.toggleSubmitButton(
            html.getElementById(`ProductSubmitButton-${this.sectionId}`)?.hasAttribute('disabled') ?? true,
            window.variantStrings.soldOut
          );

          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: this.sectionId,
              html,
              variant,
            },
          });
        };
      }

      hideSuspendedCombinations() {
        const allVariantsData = this.querySelector('variant-selects [data-all-variant]');
        if (!allVariantsData) return;
      
        const allVariants = JSON.parse(allVariantsData.textContent);

        // define helper once
        const isSuspended = v => v.ec_suspended === true || v.ec_suspended === "true";

        const suspendedVariants = allVariants.filter(isSuspended);
        const possibleVariants = allVariants.filter(v => !isSuspended(v));
        // console.log("Possible variants:", possibleVariants);

        // redirect if no possible variants left
        if (possibleVariants.length === 0) {
          console.warn("⚠️ No possible variants left, redirecting to 404");
          window.location.href = "/404"; // Shopify’s default 404 page
          return;
        }
        // end redirect
      

        if (suspendedVariants.length === 0) {
          this.querySelectorAll('label.variant--suspended').forEach(label => label.classList.remove('variant--suspended'));
          return;
        }
      
        let optionCount = 0;
        if (allVariants.some(v => v.option1)) optionCount = 1;
        if (allVariants.some(v => v.option2)) optionCount = 2;
        if (allVariants.some(v => v.option3)) optionCount = 3;
      
        const allFoundFieldsets = Array.from(this.querySelectorAll('variant-selects [data-option-index]'));
        const fieldsets = allFoundFieldsets.slice(0, optionCount);

        if (fieldsets.length === 0) return;
      
        const currentSelection = fieldsets.map(fieldset => fieldset.querySelector('input:checked')?.value || null);

        // console.log("🎯 Current selection:", currentSelection);

        // NEW BLOCK: if current variant is suspended, auto-select first possible
        const currentVariant = allVariants.find(v => {
          return (
            (!currentSelection[0] || v.option1 === currentSelection[0]) &&
            (!currentSelection[1] || v.option2 === currentSelection[1]) &&
            (!currentSelection[2] || v.option3 === currentSelection[2])
          );
        });
        // console.log("🔍 Current variant found:", currentVariant);

        if (currentVariant && isSuspended(currentVariant)) {
          console.warn("⚠️ Current variant is suspended:", currentVariant);

          const firstPossible = possibleVariants[0];
          if (firstPossible) {
            console.log("✅ Switching to first possible:", firstPossible);

            [firstPossible.option1, firstPossible.option2, firstPossible.option3].forEach((opt, i) => {
              if (!opt) return;
              const sel = `input[value="${CSS?.escape ? CSS.escape(opt) : opt}"]`;
              const input = fieldsets[i]?.querySelector(sel);
              if (input && !input.checked) {
                input.checked = true;
                input.dispatchEvent(new Event('change', { bubbles: true }));
              }
            });

            const url = `${window.location.pathname}?variant=${firstPossible.id}`;
            window.history.replaceState({}, '', url);
          }
        }
        // 🔎 END NEW BLOCK
      
        fieldsets.forEach((fieldset, optionIndex) => {
          fieldset.querySelectorAll('input').forEach(input => {
            const label = this.querySelector(`label[for="${input.id}"]`);
            if (!label) return;
          
            const inputValue = input.value;

            let shouldHide = false;
          
            // for (const suspended of suspendedVariants) {
            //   const suspendedOptions = [suspended.option1, suspended.option2, suspended.option3];
            //   const suspendedValue = suspendedOptions[optionIndex];
            
            //   if (suspendedValue && typeof suspendedValue === 'string' && inputValue.trim() === suspendedValue.trim()) {
            //     let otherOptionsMatch = true;
            //     for (let i = 0; i < currentSelection.length; i++) {
            //       if (i === optionIndex) continue;
            //       const selectedValue = currentSelection[i];
            //       const suspendedMatchValue = suspendedOptions[i];
            //       if (selectedValue && (!suspendedMatchValue || typeof suspendedMatchValue !== 'string' || selectedValue.trim() !== suspendedMatchValue.trim())) {
            //         otherOptionsMatch = false;
            //         break;
            //       }
            //     }
              
            //     if (otherOptionsMatch) {
            //       shouldHide = true;
            //       break;
            //     }
            //   }
            // }
          
            
            // Only hide the option if it should be hidden AND it's not currently checked.
            // if (shouldHide && !input.checked) {
            //   label.classList.add('variant--suspended');
            // } else {
            //   label.classList.remove('variant--suspended');
            // }

            
            // ✅ NEW: check if this inputValue is part of ANY possible variant
            const stillValid = possibleVariants.some(v => {
              const opts = [v.option1, v.option2, v.option3];
              return (
                opts[optionIndex] === inputValue &&
                // also check other selected options must match
                currentSelection.every((sel, i) => {
                  if (i === optionIndex || !sel) return true;
                  return opts[i] === sel;
                })
              );
            });

            // ✅ NEW: hide + disable invalid options instead of just marking with a class
            if (!stillValid && !input.checked) {
              label.style.display = "none";   // completely hide
              input.disabled = true;          // prevent selection
            } else {
              label.style.display = "";       // reset to visible
              input.disabled = false;
            }
            
          });
        });
      }
      
      updateVariantInputs(variantId) {
        this.querySelectorAll(
          `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
        ).forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          input.value = variantId ?? '';
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }

      updateURL(url, variantId) {
        this.querySelector('share-button')?.updateUrl(
          `${window.shopUrl}${url}${variantId ? `?variant=${variantId}` : ''}`
        );

        if (this.dataset.updateUrl === 'false') return;
        window.history.replaceState({}, '', `${url}${variantId ? `?variant=${variantId}` : ''}`);
        filterUrl(`${url}?variant=${variantId}`);
      }

      setUnavailable() {
        this.productForm?.toggleSubmitButton(true, window.variantStrings.unavailable);

        const selectors = ['price', 'Inventory', 'Sku', 'Price-Per-Item', 'Volume-Note', 'Volume', 'Quantity-Rules']
          .map((id) => `#${id}-${this.dataset.section}`)
          .join(', ');
        document.querySelectorAll(selectors).forEach(({ classList }) => classList.add('hidden'));
      }

      updateMedia(html, variantFeaturedMediaId) {
        if (!variantFeaturedMediaId) return;

        const mediaGallerySource = this.querySelector('media-gallery ul');
        const mediaGalleryDestination = html.querySelector(`media-gallery ul`);

        const refreshSourceData = () => {
          if (this.hasAttribute('data-zoom-on-hover')) enableZoomOnHover(2);
          const mediaGallerySourceItems = Array.from(mediaGallerySource.querySelectorAll('li[data-media-id]'));
          const sourceSet = new Set(mediaGallerySourceItems.map((item) => item.dataset.mediaId));
          const sourceMap = new Map(
            mediaGallerySourceItems.map((item, index) => [item.dataset.mediaId, { item, index }])
          );
          return [mediaGallerySourceItems, sourceSet, sourceMap];
        };

        if (mediaGallerySource && mediaGalleryDestination) {
          let [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
          const mediaGalleryDestinationItems = Array.from(
            mediaGalleryDestination.querySelectorAll('li[data-media-id]')
          );
          const destinationSet = new Set(mediaGalleryDestinationItems.map(({ dataset }) => dataset.mediaId));
          let shouldRefresh = false;

          // add items from new data not present in DOM
          for (let i = mediaGalleryDestinationItems.length - 1; i >= 0; i--) {
            if (!sourceSet.has(mediaGalleryDestinationItems[i].dataset.mediaId)) {
              mediaGallerySource.prepend(mediaGalleryDestinationItems[i]);
              shouldRefresh = true;
            }
          }

          // remove items from DOM not present in new data
          for (let i = 0; i < mediaGallerySourceItems.length; i++) {
            if (!destinationSet.has(mediaGallerySourceItems[i].dataset.mediaId)) {
              mediaGallerySourceItems[i].remove();
              shouldRefresh = true;
            }
          }

          // refresh
          if (shouldRefresh) [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();

          // if media galleries don't match, sort to match new data order
          mediaGalleryDestinationItems.forEach((destinationItem, destinationIndex) => {
            const sourceData = sourceMap.get(destinationItem.dataset.mediaId);

            if (sourceData && sourceData.index !== destinationIndex) {
              mediaGallerySource.insertBefore(
                sourceData.item,
                mediaGallerySource.querySelector(`li:nth-of-type(${destinationIndex + 1})`)
              );

              // refresh source now that it has been modified
              [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
            }
          });
        }

        // set featured media as active in the media gallery
        this.querySelector(`media-gallery`)?.setActiveMedia?.(
          `${this.dataset.section}-${variantFeaturedMediaId}`,
          true
        );

        // update media modal
        const modalContent = this.productModal?.querySelector(`.product-media-modal__content`);
        const newModalContent = html.querySelector(`product-modal .product-media-modal__content`);
        if (modalContent && newModalContent) modalContent.innerHTML = newModalContent.innerHTML;
      }


      setQuantityBoundries() {
        const data = {
          cartQuantity: this.quantityInput.dataset.cartQuantity ? parseInt(this.quantityInput.dataset.cartQuantity) : 0,
          min: this.quantityInput.dataset.min ? parseInt(this.quantityInput.dataset.min) : 1,
          max: this.quantityInput.dataset.max ? parseInt(this.quantityInput.dataset.max) : null,
          step: this.quantityInput.step ? parseInt(this.quantityInput.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.quantityInput.min = min;

        if (max) {
          this.quantityInput.max = max;
        } else {
          this.quantityInput.removeAttribute('max');
        }
        this.quantityInput.value = min;

        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        const currentVariantId = this.productForm?.variantIdInput?.value;
        if (!currentVariantId) return;

        this.querySelector('.quantity__rules-cart .loading__spinner').classList.remove('hidden');
        fetch(`${this.dataset.url}?variant=${currentVariantId}&section_id=${this.dataset.section}`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
          })
          .catch((e) => console.error(e))
          .finally(() => this.querySelector('.quantity__rules-cart .loading__spinner').classList.add('hidden'));
      }

      updateQuantityRules(sectionId, html) {
        if (!this.quantityInput) return;
        this.setQuantityBoundries();

        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) {
                current.setAttribute(attribute, valueUpdated);
              } else {
                current.removeAttribute(attribute);
              }
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }

      get productForm() {
        return this.querySelector(`product-form`);
      }

      get productModal() {
        return document.querySelector(`#ProductModal-${this.dataset.section}`);
      }

      get pickupAvailability() {
        return this.querySelector(`pickup-availability`);
      }

      get variantSelectors() {
        return this.querySelector('variant-selects');
      }

      get relatedProducts() {
        const relatedProductsSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'related-products'
        );
        return document.querySelector(`product-recommendations[data-section-id^="${relatedProductsSectionId}"]`);
      }

      get quickOrderList() {
        const quickOrderListSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'quick_order_list'
        );
        return document.querySelector(`quick-order-list[data-id^="${quickOrderListSectionId}"]`);
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
    }
  );
}
document.addEventListener("DOMContentLoaded", function () {
  initializeProductGallery();
});

function initializeProductGallery() {
  const thumbsEl = document.querySelector(".block_top-slider-thumb");
  const mainEl = document.querySelector(".block_top-slider-main");

  if (thumbsEl && mainEl) {
    const totalThumbs = thumbsEl.querySelectorAll('.block_top-slider-thumb .swiper-slide').length;

    // Initialize thumbs
    window.swiperThumbsInstance = new Swiper(thumbsEl, {
      spaceBetween: 0,
      slidesPerView: totalThumbs,
      freeMode: true,
      watchSlidesProgress: true,
    });

    // Initialize main slider
    window.swiperMainInstance = new Swiper(mainEl, {
      loop: true,
      spaceBetween: 10,
      watchSlidesProgress: true,
      navigation: {
        nextEl: ".block_top-slider-right-arrow",
        prevEl: ".block_top-slider-left-arrow",
      },
      thumbs: {
        swiper: window.swiperThumbsInstance,
      },
      pagination: {
        el: ".swiper-pagination",
        type: "progressbar",
      },
    });
  } else {
    console.warn("Swiper elements not found on the page.");
  }
}

// =========custom.js=====
document.addEventListener("DOMContentLoaded", function () {
  const setselectedItem = document.querySelector('.block_post-length-size input[type="radio"]:checked');
  if(setselectedItem){
    const selectedPostLength = setselectedItem.getAttribute("data-length")
    localStorage.setItem('selectedPostLength', selectedPostLength);
  }
  setTimeout(() => {
    const selectedvariantId = document.querySelector('.product-variant-id').value;
    tosOrderTags(selectedvariantId);
    postLengthInit();
  }, 700);

});
function postLengthInit() {
  const radios = document.querySelectorAll('.block_post-length-size input[type="radio"]');
  const storedValue = localStorage.getItem('selectedPostLength'); // 🔹 Retrieve previously saved selection
  
  // If we have a stored value, restore it
  if (storedValue) {
    const savedRadio = document.querySelector(`.block_post-length-size input[type="radio"][data-length="${storedValue}"]`);
    if (savedRadio) {
      savedRadio.checked = true;
    }
  }

  
    const selectedRadio = document.querySelector('.block_post-length-size input[type="radio"]:checked');
    if (document.querySelectorAll(".block_post-length-size").length > 0 && selectedRadio) {
      const relation = selectedRadio.getAttribute("data-relation");
      const length = selectedRadio.getAttribute("data-length");
      const addOnDisplayPrice = selectedRadio.getAttribute("data-add-on-price");
      const addOnPrice = selectedRadio.getAttribute("data-price");

      // Update hidden inputs
      const relationInput = document.querySelector('#product-propeties-relationKey');
      const lengthInput = document.querySelector('#product-propeties-post-length');
      const priceInput = document.querySelector('#product_add_on_price');

      if (relationInput) relationInput.value = relation;
      if (lengthInput) lengthInput.value = length;
      if (priceInput) priceInput.value = addOnDisplayPrice;

      setTimeout(() => {
        localStorage.setItem('addOnPrice', addOnDisplayPrice);
      }, 1000);
      // Update price
      if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
        const hiddenPriceInput = document.getElementById('hidden_variant_price');
        const basePrice = hiddenPriceInput && !isNaN(parseInt(hiddenPriceInput.value, 10))
          ? parseInt(hiddenPriceInput.value, 10)
          : 0;

        const addOnCents = !isNaN(parseInt(addOnPrice, 10)) ? parseInt(addOnPrice, 10) : 0;
        const totalCents = basePrice + addOnCents;
        const moneyFormat = Shopify.moneyFormat || "{{amount}}";
        let formatted = Shopify.formatMoney(totalCents, moneyFormat);
        formatted = formatted.replace(/(\d[\d,\.]*)[.,](\d{2})$/, '$1');
        const currencyCode = document.body.dataset.shopCurrency || '';

        const displayTotal = currencyCode === 'USD'      
          ? formatted
          : `${formatted} ${currencyCode}`;
        document.querySelectorAll('.price__container .price__regular .price-item--regular')
        .forEach(el => {
          el.innerHTML = displayTotal;
        });
        document.querySelectorAll('.product-form__submit')
        .forEach(el => {
          el.classList.remove('backing_block_cursor');
        });
        setTimeout(() => {
          document.querySelectorAll('.price-wrap .loading__spinner')
          .forEach(el => {
            el.classList.add('hidden');
          });
          document.querySelectorAll('.block__product-variants')
          .forEach(el => {
            el.classList.remove('backing_wrapper_prod');
          });
        }, 1500);
      }
    }else{
      document.querySelectorAll('.product-form__submit')
      .forEach(el => {
        el.classList.remove('backing_block_cursor');
      });
      setTimeout(() => {
        document.querySelectorAll('.price-wrap .loading__spinner')
          .forEach(el => {
            el.classList.add('hidden');
          });
          document.querySelectorAll('.block__product-variants')
          .forEach(el => {
            el.classList.remove('backing_wrapper_prod');
          });
      }, 1500);
    }
  
  
    // 🔹 Save new selection when user changes it
    radios.forEach(radio => {
      radio.addEventListener('change', e => {
        localStorage.setItem('selectedPostLength', e.target.getAttribute('data-length'));
        postLengthInit(); // re-run to update price and hidden inputs
      });
    });
    setTimeout(() => {
      document.querySelectorAll('.block_post-length-size').forEach(el => {
        el.classList.remove('skeleton');
      });
    }, 1000);
}

function filterUrl(url){
  if (url.match(/\?variant=/g)?.length > 1 && url.endsWith("?variant=" + url.split("?variant=").pop())) {
    url = url.slice(0, url.lastIndexOf("?variant="));
  }
  window.history.replaceState(null, "", url);
}

function tosOrderTags(varianId){

  const currentSelectionTos = sessionStorage.getItem('current_selection');
  if(currentSelectionTos){
    const data = JSON.parse(currentSelectionTos);
    const variantProductId = Object.values(data).map(item => item.variant_product_id);

    if(variantProductId.includes(Number(varianId))){
      document.getElementById("AtcType").insertAdjacentHTML(
      "beforeend",
      '<input type="hidden" name="properties[_atc]" value="TOS Influenced" id="itemTypeAtc">'
      );
    }else{
      document.querySelectorAll('input[name="properties[_atc]"]').forEach(el => el.remove());
    }
  }
}

function initStickyScroll() {
  const mediaWrapper = document.querySelector(".product__media-wrapper");
  const stickyMain = document.querySelector(".product-sticky-main");
  if (!mediaWrapper || !stickyMain) return;

  const handleScroll = () => {
    const mediaRect = mediaWrapper.getBoundingClientRect();

    // If mediaWrapper height is very small, show sticky by default
    if (mediaRect.height <= 10 || mediaRect.bottom <= 0) {
      stickyMain.classList.add("active-sticky");
    } else {
      stickyMain.classList.remove("active-sticky");
    }
  };

  // First call to set initial state
  handleScroll();

  // Remove previous listeners if any
  if (window._stickyScrollListener) {
    window.removeEventListener("scroll", window._stickyScrollListener);
  }
  if (window._stickyResizeListener) {
    window.removeEventListener("resize", window._stickyResizeListener);
  }

  // Add new listeners
  window._stickyScrollListener = handleScroll;
  window._stickyResizeListener = handleScroll;

  window.addEventListener("scroll", window._stickyScrollListener);
  window.addEventListener("resize", window._stickyResizeListener);
}

// Initialize after DOM and after Shopify product info loaded
document.addEventListener("DOMContentLoaded", initStickyScroll);
document.addEventListener("product-info:loaded", initStickyScroll);







